import { useTranslation } from "react-i18next";
import type { ContractStatusNotification as ContractStatusNotificationType } from "@/gql/graphql";
import DataListItemText from "./DataListItemText";

type NotificationProps = {
  data: Pick<ContractStatusNotificationType, "contractNumber">;
};

const AmendmentRepriceNotification = (props: NotificationProps) => {
  const { data } = props;
  const { contractNumber } = data;
  const { t } = useTranslation();

  return (
    <DataListItemText
      primary={t("notifications.amendment_reprice.title", { contractNumber })}
      secondary={t("notifications.amendment_reprice.description")}
    />
  );
};

export default AmendmentRepriceNotification;
